import { CommonModule } from '@angular/common';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { AsmEnablerService } from '@spartacus/asm/root';
import { PageComponentModule } from '../../../cms-structure/page/component/page-component.module';

/**
 * The ASM loader module takes care of loading the ASM UI
 * only in case there's a reason to do so.
 */
@NgModule({
  imports: [CommonModule, PageComponentModule],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = asmFactory(inject(AsmEnablerService));
      return initializerFn();
    }),
  ],
})
export class AsmLoaderModule {}

/**
 *
 * We do not like to block the UI, which is why we delegate loading of ASM
 * to a real component; the router and state aren't available in an optimized
 * way during the APP_INITIALIZER.
 */
export function asmFactory(asmEnablerService: AsmEnablerService) {
  const isReady = () => {
    asmEnablerService.load();
  };
  return isReady;
}
